module.exports = __webpack_public_path__ + "img/张凤荣.924c6cf3.jpg";